<template>
  <header class="top-bar">
    <div class="container top-bar-container">
      <div class="contact-info">
        <a href="tel:+84917197201" class="contact-item">
          <div class="icon-wrapper">
            <img src="../assets/images/icon-phone.svg" alt="Phone Icon" />
          </div>
          <span>(+84) 917.197.201</span>
        </a>
        <a href="mailto:contact@gpet.vn" class="contact-item">
          <div class="icon-wrapper">
            <img src="../assets/images/icon-email.svg" alt="Email Icon" />
          </div>
          <span>contact@gpet.vn</span>
        </a>
      </div>
      <!-- <div class="social-info">
        <span class="hide-on-mobile">Follow us:</span>
        <div class="social-icons">
          <a href="#"
            ><img src="../assets/images/icon-twitter.svg" alt="Twitter"
          /></a>
          <a href="#"
            ><img src="../assets/images/icon-facebook.svg" alt="Facebook"
          /></a>
          <a href="#"
            ><img src="../assets/images/icon-youtube.svg" alt="Youtube"
          /></a>
          <a href="#"
            ><img src="../assets/images/icon-instagram.svg" alt="Instagram"
          /></a>
        </div>
      </div> -->
    </div>

    <div class="head-search show-on-mobile">
      <div class="search-form">
        <input
          type="text"
          placeholder="Nhập SĐT để tìm kiếm lịch sử đặt lịch"
          v-model="phone"
          @keyup.enter="searchAppointment"
        />
        <button type="button" @click="searchAppointment" class="search-button">
          <img src="../assets/images/icon-search.svg" alt="Search Icon" />
        </button>
      </div>
    </div>
  </header>
  <section id="hero" class="hero-section">
    <div class="container hero-container">
      <!--merged image-->
      <div class="logo-container">
        <img
          src="../assets/images/logo-text.svg"
          alt="GPET VET"
          class="logo-text-img"
        />
        <img
          src="../assets/images/logo-icon.svg"
          alt="GPET VET Logo"
          class="logo-icon-img"
          style="left: 50%; transform: translateX(-50%)"
        />
      </div>
      <div class="hero-content">
        <div class="tagline-badge">
          <p>Không chỉ là làm đẹp</p>
        </div>
        <h1 class="main-headline">LÀ HÀNH TRÌNH CHĂM SÓC BẰNG SỰ YÊU THƯƠNG</h1>
        <div class="actions-container">
          <button
            class="btn btn-primary btn-schedule"
            @click="handleShowAppointment"
          >
            Đặt lịch ngay
          </button>
          <div class="search-form hide-on-mobile">
            <input
              type="text"
              v-model="phone"
              placeholder="Nhập SĐT để tìm kiếm lịch sử đặt lịch"
              @keyup.enter="searchAppointment"
            />
            <button
              type="button"
              @click="searchAppointment"
              class="search-button"
            >
              <img src="../assets/images/icon-search.svg" alt="Search Icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-dots"></div>
  </section>
  <section id="features" class="features-section">
    <div class="container features-container">
      <div class="feature-card">
        <img
          src="../assets/images/icon-clock.svg"
          alt="Clock Icon"
          class="feature-icon"
        />
        <div class="feature-content">
          <h3 class="feature-title">Chủ động thời gian</h3>
          <p class="feature-description">
            Dễ dàng đặt lịch chủ động và linh hoạt theo thời gian của bản thân
          </p>
        </div>
      </div>
      <div class="feature-card">
        <img
          src="../assets/images/icon-calendar.svg"
          alt="Calendar Icon"
          class="feature-icon"
        />
        <div class="feature-content">
          <h3 class="feature-title">Đặt lịch dễ dàng</h3>
          <p class="feature-description">
            Đăng ký lịch hẹn online dễ dàng chỉ với vài thao tác đơn giản
          </p>
        </div>
      </div>
      <div class="feature-card">
        <img
          src="../assets/images/icon-clock.svg"
          alt="Clock Icon"
          class="feature-icon"
        />
        <div class="feature-content">
          <h3 class="feature-title">Hỗ trợ 24/7</h3>
          <p class="feature-description">
            Giải đáp mọi thắc mắc của bạn nhanh chóng
          </p>
        </div>
      </div>
    </div>
  </section>

  <section id="features" class="features-section-ipad show-on-ipad">
    <div class="features-bar-ipad">
      <div class="feature-item-ipad">
        <img
          src="../assets/images/icon-nhanvien.svg"
          alt="Professional Staff Icon"
        />
        <div class="feature-text">
          <h4>NHÂN VIÊN CHUYÊN NGHIỆP</h4>
          <p>Tay nghề luôn vững vàng</p>
        </div>
      </div>
      <div class="feature-item-ipad">
        <img
          src="../assets/images/icon-lich.svg"
          alt="Flexible Schedule Icon"
        />
        <div class="feature-text">
          <h4>Lịch linh hoạt & dễ đổi/HỦY</h4>
          <p>Khách cảm thấy thoải mái</p>
        </div>
      </div>
      <div class="feature-item-ipad">
        <img src="../assets/images/icon-dichvu.svg" alt="Safe Service Icon" />
        <div class="feature-text">
          <h4>DỊCH VỤ AN TOÀN & UY TÍN</h4>
          <p>Bảo mật thông tin khách hàng</p>
        </div>
      </div>
      <div class="feature-item-ipad">
        <img src="../assets/images/icon-hotro.svg" alt="24/7 Support Icon" />
        <div class="feature-text">
          <h4>HỖ TRỢ 24/7</h4>
          <p>Liên hệ trực tiếp/tin nhắn</p>
        </div>
      </div>
    </div>
  </section>
  <section id="services" class="services-section show-on-ipad">
    <div class="container">
      <h2 class="section-title">Dịch vụ nổi bật</h2>
      <div class="services-grid">
        <article class="service-card">
          <img
            src="../assets/images/kham-theodoi.png"
            alt="Health Check-up Package"
          />
          <h3>GÓI KHÁM & THEO DÕI SỨC KHỎE</h3>
          <p>
            Dành cho kiểm tra định kỳ, phát hiện sớm bệnh lý hoặc theo dõi tình
            trạng hiện tại.
          </p>
        </article>
        <article class="service-card">
          <img
            src="../assets/images/tiem-phong.png"
            alt="Vaccination & Prevention Package"
          />
          <h3>GÓI TIÊM PHÒNG & NGỪA BỆNH</h3>
          <p>
            Mỗi giai đoạn phát triển của thú cưng đều có những nhu cầu y tế
            riêng biệt.
          </p>
        </article>
        <article class="service-card">
          <img
            src="../assets/images/spa-cham-soc.png"
            alt="Spa & Grooming Package"
          />
          <h3>GÓI SPA & CHĂM SÓC NGOẠI HÌNH</h3>
          <p>
            Dịch vụ giúp thú cưng luôn được sạch sẽ, thơm tho và rạng rỡ nhờ
            chăm sóc lông, da và vệ sinh định kỳ.
          </p>
        </article>
      </div>
    </div>
  </section>
  <section id="gallery" class="gallery-section show-on-ipad">
    <div class="gallery-grid">
      <img src="../assets/images/gallery-1.png" alt="Gallery image 1" />
      <img src="../assets/images/gallery-2.png" alt="Gallery image 2" />
      <img src="../assets/images/gallery-3.png" alt="Gallery image 3" />
      <img src="../assets/images/gallery-4.png" alt="Gallery image 4" />
      <img src="../assets/images/gallery-5.png" alt="Gallery image 5" />
      <img src="../assets/images/gallery-6.png" alt="Gallery image 6" />
      <img src="../assets/images/gallery-7.png" alt="Gallery image 7" />
      <img src="../assets/images/gallery-8.png" alt="Gallery image 8" />
      <img src="../assets/images/gallery-9.png" alt="Gallery image 9" />
      <img src="../assets/images/gallery-10.png" alt="Gallery image 10" />
    </div>
    <div class="gallery-grid-mobile" style="display: none">
      <div class="gallery-row gallery-row-1">
        <img src="../assets/images/gallery-1.png" alt="Gallery image 1" />
        <img src="../assets/images/gallery-2.png" alt="Gallery image 2" />
        <img src="../assets/images/gallery-3.png" alt="Gallery image 3" />
      </div>

      <!-- Hàng 2: 2 ảnh -->
      <div class="gallery-row">
        <img src="../assets/images/gallery-4.png" alt="Gallery image 4" />
        <img src="../assets/images/gallery-5.png" alt="Gallery image 5" />
      </div>
    </div>
  </section>

  <!--  -->
  <footer id="footer" class="site-footer">
    <div class="container footer-container">
      <hr class="footer-divider" />
      <div class="footer-main">
        <!--merged image-->
        <div class="footer-logo-container">
          <img
            src="../assets/images/logo-text-footer.svg"
            alt="GPET VET"
            class="footer-logo-text"
          />
          <img
            src="../assets/images/logo-icon-footer.svg"
            alt="GPET VET Logo"
            class="footer-logo-icon"
            style="left: 50%; transform: translateX(-50%)"
          />
        </div>
        <div class="footer-contact-info">
          <p class="contact-title mb-0">Liên hệ với chúng tôi</p>
          <a href="tel:+84917197201" class="contact-phone">(+84) 917.197.201</a>
          <div class="contact-details">
            <div class="contact-detail-item">
              <!--merged image-->
              <div class="pin-icon-container">
                <img src="../assets/images/icon-location.svg" alt="pin part" />
              </div>
              <span
                >Số 87 Đường Số 1, khu Melosa Khang Điền, Phường Phú Hữu, Thành
                phố Thủ Đức, Thành phố Hồ Chí Minh, Việt Nam</span
              >
            </div>
            <div class="contact-detail-item">
              <img
                src="../assets/images/icon-envelope.svg"
                alt="Email Icon"
                class="contact-icon"
              />
              <a href="mailto:contact@gpet.vn@gmail.com"
                >contact@gpet.vn@gmail.com</a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="copyright">Copyright ® 2025 GPET. All rights reserved</p>
        <a href="#"
          ><img
            src="../assets/images/bct-logo.png"
            alt="Bộ Công Thương"
            class="bct-logo"
        /></a>
      </div>
    </div>
  </footer>
  <!-- <div class="fab-container">
    <a href="#" class="fab-button zalo">
      <img src="../assets/images/icon-zalo.svg" alt="Zalo" />
    </a>
    <a href="#" class="fab-button messenger">
      <img src="../assets/images/icon-messenger.svg" alt="Messenger" />
    </a>
  </div> -->

  <ModalComp v-model="showModal" title="Thông tin đặt lịch hẹn" height="800px">
    <AppointmentView
      :isModal="true"
      @cancel="showModal = false"
      @confirm="handleConfirmAppointment"
    />
  </ModalComp>

  <ModalComp
    v-model="isOpen"
    @close="isOpen = false"
    size="sm"
    height="auto"
    isBack
    showCustomClose
  >
    <p class="title-qr">
      Tải QR về máy và đưa cho nhân viên quét khi tới phòng khám
    </p>
    <div class="qr-container-img">
      <img :src="qrDataUrl" alt="QR Code" />
    </div>
    <button class="download-qr" @click="downloadQR">
      <img
        src="../assets/images/icon-download.svg"
        alt="download"
        class="icon-download"
      />
      Tải về máy
    </button>
  </ModalComp>

  <LoadingComp :visible="loading" text="Đang xác thực captcha..." />
</template>

<script>
import AppointmentService from "../services/appointment.service";
import { useToast } from "vue-toastification";
import { useSearchStore } from "../stores/search.store";
import ModalComp from "@/components/ModalComp.vue";
import AppointmentView from "@/views/AppointmentView.vue";
import CategoryService from "../services/category.service";
import { TABLE_NAME } from "../constants/tableName";
import LoadingComp from "../components/LoadingComp.vue";

export default {
  name: "HomeView",
  components: {
    ModalComp,
    AppointmentView,
    LoadingComp,
  },
  setup() {
    const toast = useToast();
    const searchStore = useSearchStore();
    return { toast, searchStore };
  },
  data() {
    return {
      requireCaptcha: false,
      appointments: [],
      SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      phone: "",
      showModal: false,
      isOpen: false,
      qrDataUrl: "",
      clinicSchedule: null,
      clinicInfo: null,
      loading: false,
    };
  },
  async created() {
    await this.getClinicInfo();
  },
  mounted() {
    document.body.classList.add("home-hide-main-layout");
  },
  beforeUnmount() {
    document.body.classList.remove("home-hide-main-layout");
  },
  methods: {
    async getClinicInfo() {
      try {
        this.clinicSchedule = (
          await CategoryService.getDataByField(
            TABLE_NAME.CLINIC_SCHEDULES,
            "url",
            this.$route.params.id
          )
        )[0];

        this.clinicInfo = (
          await CategoryService.getDataByField(
            TABLE_NAME.CLINIC,
            "_id",
            this.clinicSchedule?.clinicId
          )
        )[0];

        const clinicName = this.clinicInfo?.name;
        if (clinicName) document.title = clinicName;
      } catch (e) {
        console.error(e);
      }
    },
    async handleShowAppointment() {
      this.clinicSchedule = (
          await CategoryService.getDataByField(
            TABLE_NAME.CLINIC_SCHEDULES,
            "url",
            this.$route.params.id
          )
        )[0];
      if (this.clinicSchedule.status === false) {
        this.$router.push({
          name: "unavailable",
        });
        return;
      }
      if (window.innerWidth < 835 && window.innerWidth > 576) {
        this.showModal = true;
      } else {
        this.$router.push({
          name: "appointment",
          params: { id: this.$route.params.id },
        });
      }
    },
    async searchAppointment() {
      if (!this.phone) {
        this.toast.error("Vui lòng nhập SĐT để tìm kiếm lịch sử đặt lịch.");
        return;
      }
      this.appointments = [];
      this.requireCaptcha = false;
      try {
        this.clinicSchedule = (
          await CategoryService.getDataByField(
            TABLE_NAME.CLINIC_SCHEDULES,
            "url",
            this.$route.params.id
          )
        )[0];
        const res = await AppointmentService.searchAppointment(
          this.phone,
          this.clinicSchedule?.clinicId,
          null
        );
        this.appointments = res;

        this.searchStore.setResults(this.appointments);
        this.searchStore.setQuery(this.phone);
        this.$router.push({ name: "history" });
      } catch (err) {
        this.requireCaptcha = true;
        await this.runRecaptchaAndRetry();
      }
    },

    async runRecaptchaAndRetry() {
      if (!window.grecaptcha) {
        this.toast.error("Recaptcha chưa tải được, thử reload trang.");
        return;
      }

      try {
        this.loading = true;
        const token = await new Promise((resolve, reject) => {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute(this.SITE_KEY, { action: "search" })
              .then(resolve)
              .catch(reject);
          });
        });

        const res = await AppointmentService.searchAppointment(
          this.phone,
          this.clinicSchedule?.clinicId,
          token
        );
        this.appointments = res;

        this.searchStore.setResults(this.appointments);
        this.searchStore.setQuery(this.phone);

        this.requireCaptcha = false;
        this.loading = false;
        this.$router.push({ name: "history" });
      } catch (ex) {
        this.toast.error("Xác thực captcha thất bại, vui lòng thử lại.");
      }
    },

    handleConfirmAppointment(qrDataUrl) {
      this.showModal = false;
      this.isOpen = true;
      this.qrDataUrl = qrDataUrl;
    },
    downloadQR() {
      const link = document.createElement("a");
      link.href = this.qrDataUrl;
      link.download = "qr-code.png";
      link.click();
    },
  },
};
</script>

<style scoped>
:global(body.home-hide-main-layout header.site-header),
:global(body.home-hide-main-layout .head-mobile) {
  display: none !important;
}

:global(body.home-hide-main-layout .main-container) {
  padding-top: 0 !important;
  min-height: 100vh !important;
}

.top-bar {
  background-color: rgba(36, 36, 36, 0.8);
  color: var(--light-color);
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.top-bar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.contact-info,
.social-info,
.contact-item,
.social-icons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.contact-info {
  gap: 20px;
}

.contact-info a {
  text-decoration: none;
  color: var(--light-color);
}

.contact-info span {
  font-style: italic;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: var(--light-color);
}

.contact-item {
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
}

.icon-wrapper {
  background-color: var(--light-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-wrapper img {
  width: 20px;
  height: 20px;
}

.social-info {
  gap: 12px;
  font-size: 14px;
}

.social-icons {
  gap: 12px;
}

.social-icons a img {
  width: 16px;
  height: 16px;
}

@media (max-width: 992px) {
  .top-bar-container {
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .contact-info {
    align-items: flex-start;
    gap: 10px;
  }
}

/* CSS for section section:hero */
.hero-section {
  background-image: url("../assets/images/background-hero.png");
  background-size: cover;
  background-position: center;
  min-height: 982px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.hero-container {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 105px;
  gap: 150px;
}

.logo-container {
  position: relative;
  width: 175px;
  height: 146px;
}

.logo-container img {
  position: absolute;
}

.logo-text-img {
  bottom: 0;
  left: 0;
}

.logo-icon-img {
  top: 0;
  right: 0;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  max-width: 860px;
}

.tagline-badge {
  background-color: var(--primary-color);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 50px;
  gap: 10px;
  width: 475px;
  height: 55px;
  background: #076c71;
  border-radius: 0px 50px;
}

.tagline-badge p {
  color: var(--light-color);
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 35px;
  font-style: normal;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: 0;
}

.main-headline {
  color: var(--light-color);
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: 60px;
  line-height: 1.33;
  text-shadow: 2px 2px 4px rgba(72, 72, 72, 0.6);
  text-align: left;
}

.actions-container {
  display: flex;
  gap: 29px;
  width: 100%;
  flex-wrap: wrap;
  margin-top: -10px;
}

.btn.btn-primary {
  background-color: var(--primary-color);
  color: var(--light-color);
  font-size: 25px;
  font-weight: 600;
  padding: 25px 20px;
  border-radius: 10px;
  text-align: center;
  flex-shrink: 0;
}

.btn-schedule {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;
  background: #076c71;
  border-radius: 10px;
  border: none;
  font-style: italic;
  font-weight: 600;
  font-size: 25px;
  color: var(--light-color);
  height: 70px;
  transition: all 0.2s ease;
}

.btn-schedule:hover,
.btn-schedule:active {
  background-color: var(--primary-color) !important;
  opacity: 0.9;
}

.search-form {
  background-color: var(--light-color);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
  flex-grow: 1;
}

.search-form input {
  border: none;
  outline: none;
  background: transparent;
  padding: 10px 20px;
  font-size: 20px;
  color: var(--text-light);
  width: 100%;
}

.search-form input::placeholder {
  color: var(--text-light);
}

.search-button {
  background-color: var(--primary-color);
  border: none;
  border-radius: 10px;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.search-button img {
  width: 40px;
  height: 40px;
}

.slider-dots {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

@media (max-width: 992px) {
  .hero-section {
    min-height: auto;
    padding: 150px 0 80px;
  }

  .hero-container {
    gap: 80px;
  }

  .main-headline {
    font-size: 48px;
  }

  .tagline-badge p {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .main-headline {
    font-size: 36px;
  }

  .tagline-badge {
    padding: 12px 30px;
  }

  .tagline-badge p {
    font-size: 22px;
  }

  .actions-container {
    gap: 20px;
  }

  .btn.btn-primary {
    font-size: 20px;
    padding: 20px;
  }

  .search-form input {
    font-size: 16px;
  }
}

/* CSS for section section:features */
.features-section {
  padding-bottom: 60px;
  margin-top: -65px;
  position: relative;
  z-index: 5;
}

.features-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.feature-card {
  background-color: var(--light-color);
  border-radius: 10px;
  padding: 28px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: 131px;
}

.feature-icon {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
}

.feature-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: left;
}

.feature-title {
  color: var(--primary-color);
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 0;
  font-style: normal;
  line-height: 20px;
}

.feature-description {
  color: var(--text-color);
  font-size: 16px;
  line-height: 1.25;
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: left
}

@media (max-width: 992px) {
  .features-section {
    margin-top: 0;
  }

  .features-container {
    grid-template-columns: 1fr;
  }
}

/* CSS for section section:footer */
.site-footer {
  background-color: var(--primary-color);
  color: var(--light-color);
  padding: 20px 0;
  margin-top: -126px;
}

.footer-container {
  display: flex;
  flex-direction: column;
  max-width: 1400px;
}

.footer-main {
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 50px 0;
}

.footer-logo-container {
  position: relative;
  width: 175px;
  height: 146px;
  flex-shrink: 0;
}

.footer-logo-container img {
  position: absolute;
}

.footer-logo-text {
  bottom: 0;
  left: 0;
}

.footer-logo-icon {
  top: 0;
  right: 0;
}

.footer-contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: left;
}

.footer-contact-info a {
  text-decoration: none;
  color: var(--light-color);
}

.contact-title {
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  color: var(--light-color);
}

.contact-phone {
  font-size: 25px;
  font-weight: 700;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 18px;
  line-height: 1.33;
}

.contact-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-top: 2px;
}

.pin-icon-container {
  position: relative;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.footer-divider {
  height: 0.5px;
  background-color: var(--light-color);
  opacity: 1;
  margin-top: 115px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 24px 0;
}

.copyright {
  font-size: 14px;
  margin-bottom: 0;
}

.bct-logo {
  height: 66px;
  width: auto;
}

@media (max-width: 992px) {
  .footer-main {
    align-items: flex-start;
    text-align: left;
  }

  .footer-bottom {
    align-items: center;
    text-align: center;
    padding-bottom: 0;
  }

  .hero-container {
    margin-top: 0;
  }
}

/* CSS for section section:fab */
.fab-container {
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.fab-button {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}

.fab-button:hover {
  transform: scale(1.1);
}

.fab-button img {
  width: 40px;
  height: 40px;
}

.fab-button.zalo {
  background-color: #0068ff;
}

.fab-button.messenger {
  background-color: #2599ff;
}

/* --- */
/* CSS for section section:features */
.features-section-ipad {
  padding: 0 40px;
  margin-top: -40px;
  position: absolute;
  z-index: 10;
}

.features-bar-ipad {
  background-color: var(--light-color);
  border: 0.7px solid #e4e7e9;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 11px 0;
}

.feature-item-ipad {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  flex: 1;
  justify-content: center;
}

.feature-item-ipad:not(:last-child) {
  border-right: 0.7px solid #e4e7e9;
}

.feature-item-ipad img {
  width: 27px;
  height: 27px;
}

.feature-text h4 {
  margin: 0 0 3px 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-color);
}

.feature-text p {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #5f6c72;
}

@media (max-width: 900px) {
  .features-bar-ipad {
    flex-wrap: wrap;
  }

  .feature-item-ipad {
    flex-basis: 50%;
    padding: 15px;
    border-right: none !important;
  }

  .feature-item-ipad:nth-child(odd) {
    border-right: 0.7px solid #e4e7e9 !important;
  }

  .feature-item-ipad:nth-child(1),
  .feature-item-ipad:nth-child(2) {
    border-bottom: 0.7px solid #e4e7e9;
  }
}

@media (max-width: 500px) {
  .features-section-ipad {
    padding: 0 20px;
  }

  .feature-item-ipad {
    flex-basis: 100%;
    border-right: none !important;
  }

  .feature-item-ipad:not(:last-child) {
    border-bottom: 0.7px solid #e4e7e9;
  }
}

/* CSS for section section:services */
.services-section {
  padding: 150px 0 34px 0;
  background-color: var(--background-light);
}

.section-title {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: var(--primary-color);
  margin-top: 0;
  margin-bottom: 30px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.service-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
}

.service-card img {
  width: 100%;
  height: 190px;
  object-fit: cover;
  border-radius: 5.4px;
}

.service-card h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0 0 0;
  color: var(--text-color);
}

.service-card p {
  font-size: 12px;
  font-weight: 400;
  color: var(--text-light);
  line-height: 1.6;
  margin: 0;
}

/* CSS for section section:gallery */
.gallery-section {
  padding: 34px 0 0 0;
  background-color: var(--light-color);
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1px;
}

.gallery-grid img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

@media (max-width: 480px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.show-on-ipad,
.show-on-mobile {
  display: none;
}

@media (max-width: 992px) {
  .show-on-ipad {
    display: block;
  }

  .features-section {
    display: none;
  }
}

@media screen and (min-width: 768px) and (max-width: 835px) {
  .contact-item {
    font-size: 12px;
  }

  .logo-text-img {
    width: 119px;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }

  .logo-icon-img {
    width: 65px;
  }

  .hero-content {
    padding-bottom: 40px;
  }

  .hero-container {
    gap: 40px;
  }

  .tagline-badge {
    width: 400px;
  }

  .btn-schedule,
  .search-form {
    height: 60px;
    font-size: 22px !important;
  }

  .search-button {
    height: 53px;
  }

  .footer-main {
    padding: 30px 0;
  }

  .site-footer {
    height: unset;
    z-index: 1;
    position: relative;
    margin-top: -70px;
  }

  .footer-bottom {
    padding: 0px;
  }

  .footer-divider {
    margin-top: 60px;
  }
}

@media (width: 768px) {
  .tagline-badge {
    width: 340px;
  }
}

@media screen and (max-width: 576px) {
  .show-on-mobile {
    display: block;
  }

  .contact-info span {
    font-size: 10px;
  }

  .icon-wrapper {
    width: 20px;
    height: 20px;
  }

  .icon-wrapper img {
    width: 15px;
    height: 20px;
  }

  .hide-on-mobile {
    display: none !important;
  }

  .footer-logo-text {
    width: 100px;
  }

  .top-bar {
    background-color: #242424;
  }

  .head-search input {
    font-size: 10px;
    padding-left: 10px;
  }

  .head-search {
    margin-top: 10px;
    margin-left: 12px;
    margin-right: 12px;
  }

  .head-search .search-button {
    width: 22px;
    height: 20px;
    background-color: #242424;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  .head-search .search-button img {
    width: 15px;
    height: 15px;
  }

  .search-form {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 4px;
    gap: 2.47px;
    height: 30px;
    background: #ffffff;
    border-radius: 100px;
  }

  .logo-icon-img {
    width: 50px;
  }

  .logo-text-img {
    width: 110px;
    top: 60px;
  }

  .tagline-badge {
    width: 242px;
    height: 40px;
  }

  .tagline-badge p {
    font-size: 17px;
  }

  .btn-schedule {
    height: 30px;
    font-size: 14px !important;
    border-radius: 5px !important;
  }

  .feature-item-ipad {
    justify-content: flex-start;
  }

  .features-bar-ipad {
    padding: 0px;
  }

  .features-bar-ipad .feature-item-ipad {
    padding: 20px 15px;
    margin: 0 18px;
    border-right: none !important;
  }

  .services-section {
    padding-top: 300px;
  }

  .services-grid {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 10px;
    margin: 0 15px;
  }

  .service-card {
    width: 100%;
    flex: 0 0 auto;
    scroll-snap-align: start;
  }

  .main-headline {
    font-size: 25px;
  }

  .top-bar-container {
    gap: 0px;
  }

  .section-title {
    margin-bottom: 10px;
  }

  .gallery-grid {
    display: none;
  }

  .gallery-grid img {
    width: 50vw;
    height: auto;
    object-fit: cover;
  }

  .gallery-grid-mobile {
    display: block !important;
    position: absolute;
    overflow: hidden;
  }

  .gallery-grid-mobile img {
    border: 1px solid white;
  }

  .copyright {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #adb7bc;
  }

  .contact-details {
    gap: 5px;
  }

  .footer-main {
    padding: 0px;
  }

  .bct-logo {
    width: 63px;
    height: auto;
  }

  .gallery-row {
    display: flex;
    flex-wrap: nowrap;
    width: 100vw;
  }

  .gallery-row-1 {
    position: relative;
    left: -25%;
  }

  .gallery-row img {
    width: 50vw;
    height: auto;
    object-fit: cover;
    display: block;
  }

  .footer-logo-text {
    width: 87px;
    left: 50%;
    transform: translateX(-50%);
    top: 59px;
  }

  .footer-logo-icon {
    left: 50%;
    transform: translateX(-50%);
    width: 47px;
  }

  .site-footer {
    height: unset;
    background: url("../assets/images/footer-bg-mobile.svg") no-repeat center
      center;
    position: relative;
    top: 310px;
    background-size: 100% auto;
  }

  .hero-container {
    padding-left: 20px;
    gap: 0px;
  }

  .logo-container {
    width: 120px;
  }

  .footer-logo-container {
    display: none;
  }

  .contact-phone,
  .contact-detail-item {
    font-size: 10px;
  }

  .contact-title {
    font-size: 12px;
  }

  .footer-contact-info {
    gap: 10px;
  }

  .contact-detail-item {
    gap: 5px;
    align-items: center;
  }

  .contact-detail-item img {
    width: 20px;
    height: 20px;
  }

  .footer-divider {
    display: none;
  }

  .footer-bottom {
    padding: 10px 0 0;
  }

  .footer-container {
    margin-top: 50px;
  }
}

.title-qr {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  color: var(--primary-color);
}

.qr-container-img {
  border: 1px solid var(--primary-color);
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-bottom: 20px;
  border-radius: 10px;
}

.qr-container-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.download-qr {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 5px;
  height: 48px;
  background: var(--primary-color);
  border-radius: 2px;
  color: var(--white-color);
  width: 100%;
  border: none;
}
</style>
